export const CONNECTED_ERP_SERVICE = 'f7bb79cf-7cfc-450e-9034-aea4e05b7fa7'
export const CONNECTED_ERP_SERVICE_FAILED = '5bf0b8c8-43a5-4c44-8e4f-6de892063e92'
export const CONNECTED_ERP_SERVICE_SUCCESS = '81449a65-387d-422b-8089-512a7d72ce22'